import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { AFFILIATE_LINKS } from "@/lib/content";

// Client-side affiliate redirect (no server needed).
// Used by inline blog links like /go/ticketmaster.
export default function GoRedirect() {
  const { slug } = useParams();
  const target = AFFILIATE_LINKS[slug];

  useEffect(() => {
    if (target) window.location.replace(target);
  }, [target]);

  if (!target) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-400">
      Je wordt doorgestuurd...
    </div>
  );
}
